import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundaryBugSnag } from "utils/crashReporter";
import FallbackComponent from "./FallbackComponent";

const ErrorBoundary = (props) => (
  <ErrorBoundaryBugSnag FallbackComponent={FallbackComponent}>
    {props.children || null}
  </ErrorBoundaryBugSnag>
);

ErrorBoundary.propTypes = {
  children: PropTypes.any,
};

ErrorBoundary.whyDidYouRender = false;

export default ErrorBoundary;
